import { safeRedirectPath } from "./safeRedirect";

export const POST_AUTH_REDIRECT_KEY = "bac_post_auth_redirect";

/** Both modal and inline authentication use the same safe continuation. */
export function rememberPostAuthNext(next: string | undefined | null): void {
  try {
    const safe = safeRedirectPath(next);
    if (safe && safe !== "/") sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, safe);
    else sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
  } catch { /* Storage may be unavailable; the current route remains usable. */ }
}
